module.exports = __webpack_public_path__ + "static/img/code-syb.70c79ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code-syb.png
// module id = kuqX
// module chunks = 1